var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudioOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.654,
    height: 22.976,
    viewBox: "0 0 27.654 22.976",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-linecap: square;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        stroke-linejoin: round;\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_730",
    "data-name": "Group 730",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_337",
    "data-name": "Rectangle 337",
    className: "cls-1",
    width: 2.625,
    height: 6.819,
    rx: 0.5,
    transform: "translate(-1 7.076)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    className: "cls-2",
    d: "M486.325,700.339l6.54,6.076V685.439l-6.54,6.076Z",
    transform: "translate(-480.7 -685.439)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    className: "cls-3",
    d: "M496.185,692.084a3.9,3.9,0,0,1,.087,7.452",
    transform: "translate(-478.55 -685.338)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    className: "cls-3",
    d: "M497.374,688.1a8.133,8.133,0,0,1,.182,15.533",
    transform: "translate(-478.532 -685.398)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioOn);
export default __webpack_public_path__ + "static/media/audio_on.32031540.svg";
export { ForwardRef as ReactComponent };